// src/asleepPositions.js

// Allar flugurnar – normalized 0–1 (byggt á 1920x1080)
export const FLY_SLOTS = [
{ x: 0.279, y: 0.198 },
{ x: 0.369, y: 0.17 },  // 709x184
{ x: 0.42, y: 0.172 },  // 806x186
{ x: 0.466, y: 0.073 },  // 894x79
{ x: 0.499, y: 0.178 },  // 959x192
{ x: 0.54, y: 0.139 },  // 1037x150
{ x: 0.572, y: 0.088 },  // 1099x95
{ x: 0.697, y: 0.262 },  // 1339x283
{ x: 0.577, y: 0.205 },  // 1107x221
{ x: 0.452, y: 0.219 },  // 869x237
{ x: 0.403, y: 0.235 },  // 773x254
{ x: 0.278, y: 0.346 },  // 534x374
{ x: 0.418, y: 0.341 },  // 803x368
{ x: 0.475, y: 0.336 },  // 912x363
{ x: 0.528, y: 0.347 },  // 1014x375
{ x: 0.577, y: 0.286 },  // 1108x309
{ x: 0.628, y: 0.349 },  // 1206x377
{ x: 0.825, y: 0.28 },  // 1585x303
{ x: 0.817, y: 0.421 },  // 1569x455
{ x: 0.748, y: 0.498 },  // 1435x537
{ x: 0.659, y: 0.47 },  // 1265x508
{ x: 0.552, y: 0.462 },  // 1061x499
{ x: 0.499, y: 0.434 },  // 958x468
{ x: 0.396, y: 0.407 },  // 760x440
{ x: 0.33, y: 0.446 },  // 634x482
{ x: 0.261, y: 0.514 },  // 501x555
{ x: 0.188, y: 0.555 },  // 362x599
{ x: 0.302, y: 0.601 },  // 579x649
{ x: 0.383, y: 0.559 },  // 734x603
{ x: 0.484, y: 0.566 },  // 929x612
{ x: 0.527, y: 0.623 },  // 1012x673
{ x: 0.564, y: 0.577 },  // 1083x623
{ x: 0.614, y: 0.617 },  // 1179x666
{ x: 0.674, y: 0.577 },  // 1294x623
{ x: 0.717, y: 0.678 },  // 1377x732
{ x: 0.645, y: 0.689 },  // 1238x744
{ x: 0.592, y: 0.708 },  // 1137x765
{ x: 0.516, y: 0.728 },  // 991x786
{ x: 0.44, y: 0.728 },  // 844x786
{ x: 0.376, y: 0.721 },  // 721x779
{ x: 0.314, y: 0.702 },  // 602x758
{ x: 0.247, y: 0.701 },  // 474x757
{ x: 0.141, y: 0.816 },  // 271x882
{ x: 0.266, y: 0.803 },  // 511x868
{ x: 0.324, y: 0.85 },  // 623x918
{ x: 0.385, y: 0.828 },  // 739x894
{ x: 0.44, y: 0.914 },  // 845x987
{ x: 0.552, y: 0.781 },  // 1061x843
{ x: 0.635, y: 0.774 },  // 1220x836
{ x: 0.744, y: 0.763 }  // 1429x824
];

// Hversu margar rásir með audio:
// Mars:  11 stems
// Palli: 8 stems
// Agust: 7 stems
// Siggi: 7 stems

export const SONG_LAYOUT = {
  Mars: {
    slotStart: 4,
    count: 11
  },
  Palli: {
    slotStart: 20,
    count: 8
  },
  Agust: {
    slotStart: 30,
    count: 7
  },
  Siggi: {
    slotStart: 41,
    count: 7
  }
};
